// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * TLM Kit
 *
 * Copyright © 2007-present SOHO Systems and Networks. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

:root {
  /*
   * Typography
   * ======================================================================== */

  /*
   * Layout
   * ======================================================================== */

  /*
   * Media queries breakpoints
   * ======================================================================== */  /* Extra small screen / phone */  /* Small screen / tablet */  /* Medium screen / desktop */ /* Large screen / wide desktop */
}

.leSF_ {
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
}

.Xxtbp {
  padding-top: 20%;
}

.Jb8M3 {
  margin: 10px auto;
  max-width: 700px;
}

.DxWxx {
  font-family: Oswald, sans-serif;
  font-size: 25px;
}

.MvjgT {
  line-height: 20px;
  font-family: Oswald, sans-serif;
  background-color: #0074c2;
  padding-left: 5px;
  padding-right: 5px;
  color: white;
  font-weight: bold;
  border-radius: 2px !important;
  display: inline-block;
}

.D1KTo {
  padding-left: 5px;
  font-family: Oswald, sans-serif;
  color: #757575;
  display: inline-block;
}

.IO3ys {
  padding-top: 10px;
}

.IO3ys p {
  line-height: 1.5em;
  font-size: 16px;
  color: rgb(72, 59, 59);
  margin-bottom: 18px;
}

.gS5gL {
  height: 100%;
  width: auto;
  max-width: 100%;
  display: inline-block;
  -o-object-fit: contain;
     object-fit: contain;
}

#news-read-carousel {
  position: relative;
}

#news-read-carousel .swiper-button-prev,
#news-read-carousel .swiper-button-next {
  width: 28px;
  height: 36px;
  top: 197px;
  margin-top: -18px;
  background-color: #0074c2;
  color: white;
}

#news-read-carousel .swiper-button-prev {
  left: 0;
  border-radius: 0 6px 6px 0;
}

#news-read-carousel .swiper-button-next {
  right: 0;
  border-radius: 6px 0 0 6px;
}

#news-read-carousel .swiper-button-disabled {
  pointer-events: auto;
  cursor: default;
}

#news-read-carousel .swiper-button-prev::after,
#news-read-carousel .swiper-button-next::after {
  font-size: 14px;
  font-weight: bold;
}

#news-read-carousel .swiper-button-prev svg,
#news-read-carousel .swiper-button-next svg {
  width: 55%;
  height: 55%;
}

#news-read-carousel .swiper-button-prev svg,
#news-read-carousel .swiper-button-prev .B7XAG {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

#news-read-carousel .swiper-pagination {
  position: static;
  margin-top: 8px;
}

#news-read-carousel .swiper-pagination-bullet {
  background: #999;
  opacity: 0.7;
}

#news-read-carousel .swiper-pagination-bullet-active {
  background: #0074c2;
  opacity: 1;
}

.zxEVF {
  font-size: 16px;
  line-height: 17px;
  text-align: left;
  color: #0074c2;
  margin-top: 5px;
  margin-bottom: 5px;
  padding-left: 7px;
  border-left: 2px solid #0074c2;
  font-family: Dosis, sans-serif;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.RAXm1 {
  margin-top: 10px;
  width: 100%;
  max-width: 700px;
  height: 394px;
  aspect-ratio: 700 / 394; /* stylelint-disable-line property-no-unknown */
  background-color: black;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  contain: layout style;
  text-align: center;
}

.XJ6JA {
  background-color: black;
  padding-left: 5px;
  padding-right: 5px;
  font-family: Dosis, sans-serif;
  color: white;
  border-radius: 2px !important;
  margin-left: 5px;
  display: inline-block;
  line-height: 20px;
}

.DKg_m {
  line-height: 23px;
  padding-bottom: 5px;
}

/* For smartphone */

@media (max-width: 650px) {
  .RAXm1 {
    margin-top: 10px;
    width: 100%;
    max-width: 700px;
    height: 54vw;
    aspect-ratio: auto; /* stylelint-disable-line property-no-unknown */
    background-color: black;
    margin-left: auto;
    margin-right: auto;
  }

  #news-read-carousel .swiper-button-prev,
  #news-read-carousel .swiper-button-next {
    top: 27vw;
  }
}

.fTSFa,
.ijzXJ {
  display: inline-block;
  vertical-align: top;
}

@-webkit-keyframes QlYiN {
  0% {
    margin-left: -500px;
  }

  100% {
    margin-left: 0;
  }
}

.ORo8c {
  margin-top: 1px;
  border-radius: 16px;
  height: 31px;
  width: 31px;
  border: 1px solid black;
  cursor: pointer;
  padding: 7px;
}

.dGDlf {
  padding: 0 1px;
  cursor: pointer;
  margin-bottom: 5px;
}

.iOyT2 {
  border: 1px solid #0074c2;
  color: #0074c2;
  border-radius: 5px;
  padding: 0 6px;
  font-family: Dosis, sans-serif;
}

/* For PC and tablet */

@media (min-width: 900px) {
  .fTSFa {
    width: 70%;
  }

  .ijzXJ {
    width: 30%;
    padding-left: 15px;
  }

  .ijzXJ .mb3yC {
    float: left;
  }

}

.O5EwW {
  margin-top: -10px;
}

._Wrf8 {
  width: 100%;
  display: inline-block;
  margin-top: 10px;
}

.mb3yC {
  font-family: Oswald, sans-serif;
  display: inline-block;
  font-size: 20px;
  text-transform: uppercase;

  /* background-color: black; */
  color: #1a72b5;
  padding: 0;
}

.FCHei {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
      justify-content: space-between;
  -ms-flex-align: start;
      align-items: flex-start;
  gap: 10px;
  margin-top: 5px;
}

.FCHei > div:last-child {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
      align-items: center;
  gap: 6px;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

.l8yyH {
  position: fixed;
  top: 55px;
  left: 0;
  right: 0;
  width: 70% !important;
  z-index: 990;
  -ms-flex-pack: center;
      justify-content: center;
  contain: layout style paint; /* stylelint-disable-line property-no-unknown */
}

@media (min-width: 1200px) {
  .l8yyH {
    position: fixed;
    top: 55px;
    left: 0;
    right: 0;
    width: 705px !important;
    z-index: 990;
  }
}

/* For medium and small screen */

@media (max-width: 900px) {
  .fTSFa {
    width: 100%;
  }

  .ijzXJ {
    width: 100%;
  }

  .l8yyH {
    position: fixed;
    top: 55px;
    left: 0;
    right: 0;
    width: 100% !important;
    margin: 0 auto;
    z-index: 990;
  }
}

/* For smartphone */

@media (max-width: 650px) {
  .DKg_m {
    width: 100%;
  }
}

.LhNN8 {
  margin-top: 10px;
  margin-bottom: 10px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `leSF_`,
	"newsMainSection": `Xxtbp`,
	"container": `Jb8M3`,
	"newsTitle": `DxWxx`,
	"publicationTag": `MvjgT`,
	"publicationDate": `D1KTo`,
	"articleContainer": `IO3ys`,
	"articleImage": `gS5gL`,
	"swiper-navigation-icon": `B7XAG`,
	"imageCaption": `zxEVF`,
	"imageContainer": `RAXm1`,
	"articleTag": `XJ6JA`,
	"tagArea": `DKg_m`,
	"leftSection": `fTSFa`,
	"rightSection": `ijzXJ`,
	"circleLink": `ORo8c`,
	"shareLink": `dGDlf`,
	"viewCountBox": `iOyT2`,
	"sectionTitle": `mb3yC`,
	"squareNewsListContainer": `O5EwW`,
	"sectionTitleContainer": `_Wrf8`,
	"subContainer": `FCHei`,
	"adsFixSection": `l8yyH`,
	"adsInlineSection": `LhNN8`,
	"slide": `QlYiN`
};
module.exports = ___CSS_LOADER_EXPORT___;
